module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "sp",
    attrs: {
      "id": "ch3"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "CN"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/contents#c_ch3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("THREE")])]), _vm._v(" "), _c('p', {
    staticClass: "CO"
  }, [_vm._v("I avoid jogging down my usual path for the next week, hoping to avoid running into Noah again at all costs. He’s tried to call a few times, but I figure he’s learned by now it doesn’t matter how much he calls because I won’t answer. I have nothing to say. I’m trying to move on with my life.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“Ma’am, the line has moved forward.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("I jerk out of my thoughts and shuffle ahead in the Starbucks line I’ve been waiting in for the last ten minutes. It’s my job to get coffee for my work colleagues every day. So I spend close to half an hour in here every day because I am forced to come at peak time. I don’t mind, though; it lets me drift off into my own little world where no one bothers me.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“Sorry,” I mumble to the man behind me.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("I reach the front of the line after another five minutes.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“What can I get for you?” the sour young man says, clearly bored with his day already. Is it so much to ask for good customer service these days?")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“Two grande cappuccinos, two grande lattes, one venti iced coffee.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("He nods and scribbles it onto the cups with my name and I move to the group waiting for the drinks to be made. The girls behind the counter are in no hurry either, chatting happily about their weekends and the men they’re dating, taking their sweet time to make the drinks that everyone is waiting for.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“Morning.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("The voice comes from behind me, and I turn and see a middle-aged man sitting at a table just to my left. I glance around, not sure if he’s talking to me, but realize that he’s looking directly at me. Maybe he’s confused, or maybe he’s just friendly. That would be a nice change. “Ah, morning.” I smile shyly.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“Long wait, isn’t it?”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("I nod. “It is.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“You doing the morning run for your workplace?”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("I laugh softly. “Is it that obvious?”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("He smiles. He’s good looking. Blond hair, blue eyes, all-American-boy smile. He seems like the type of man Rachel would swoon over.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“It’s always the quiet ones,” he says, almost to himself.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("I give him another smile and turn back to the line.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“Do you work around here?”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("Why is he talking to me? People don’t usually make the effort to talk to me, because I tend to keep my head down. “Just up the road at the Morgan and Francis law firm,” I mumble.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("He nods. “I’ve heard good things about them.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("I shrug. “I’m just a receptionist.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("He smiles. “You don’t seem like the type to be just a receptionist.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“I guess you read me wrong.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("His smile widens. “I never read people wrong.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Okay.")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“Lara.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("The sound of Noah’s voice to my left has me spinning around. He stands in the line, studying me. God, it’s as if I can’t escape him. This is borderline stalking now. He’s probably following me. He’s a take-action kind of man and if he wants something, he gets it. Still, if he thinks I’m going to give him the satisfaction of talking to him, he can look elsewhere. I’m not going to listen to what he has to say.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“Did you follow me here, too?” I ask.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("He narrows his eyes. “I like coffee, and it’s close to my new job. I don’t think that’s considered following you.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("I clench my teeth but say nothing.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("He looks good today. He’s been a firefighter for six years. He started as a volunteer years ago but quickly became chief. His job is his life. It works for him. It suits him. A good portion of the women in Starbucks are staring at him, and I can’t blame them. He’s wearing a tight black tee but it’s the yellow pants slung low around his hips, dirty from wear, that make him irresistible. They’re probably seriously considering lighting their houses on fire just to get him to save them.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("I can’t say I blame them.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“We can do this every day or you can just talk to me and then I’ll leave you alone if you want,” he says, moving closer and leaning down so his voice is close to my ear. I shiver at the hot breath that tickles my neck.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("He’s leaning down close, way too close.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("I take a step to the side. “I’ve told you there’s nothing to say.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("He growls, low in his chest. “God, you fucking drive me crazy. Why can’t you just hear me out?”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("I swallow but say nothing. I collect my coffee and leave.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("I need a damned vacation.")]), _vm._v(" "), _c('p', {
    staticClass: "SB-STD"
  }, [_vm._v("*   *   *")]), _vm._v(" "), _c('p', {
    staticClass: "Space-Break--"
  }, [_vm._v("I walk out of work later that night, tired from a long day. It’s dark out and the streetlight shines down just over my car, which is comfortably parked a little too close to the curb. I’m looking forward to going home and getting some sleep. My mind is a complete mess at the moment and frankly, I’m ready to get away from it all.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("From him.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“Lara.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("I exhale loudly. For the past three months, I thought I’d never see him again, and now I see him every single time I think about him. I turn slowly and see Noah leaning against a lamppost, arms crossed, studying me.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“There’s a law against stalking, Noah,” I say, pulling my keys from my purse.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("He pushes off the post and walks toward me. “I’m not stalking you, I was just waiting for you to finish work so we could talk.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“What part of "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("I don’t want to")]), _vm._v(" are you not grasping?” I mumble, unlocking my car.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("He steps forward as I go to pull my door open and presses his body against mine, putting his hand on the roof of my car and effectively trapping me.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“Noah,” I breathe, going weak at the very feeling of him pressing against me.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“We’re going to talk.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("I hate that he thinks he can dictate what we will and will not do. I used to love that about him. Now I hate it.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“No,” I say, trying to shove him away so I can open my door and leave.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“Lara,” he sighs. “You left me, moved out without a word, shut down for months, and didn’t give me one second of your time. I left for training, I called but didn’t push. I wanted to give you time, because I respected that you needed it. Now I’m done waiting. We’re talking.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“No, we’re not.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“Jesus, when did you get so damned stubborn and unreasonable?”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("That just makes me angrier, but I squash it down and take a deep, shaky breath. “I’m not ready for this and I don’t think I’ll ever be. Now get off me, Noah, or I’ll scream.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“Seriously?” he says, exasperated. “Why the hell would you do that?”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("I twist so I’m facing him, then tilt my head back and look up. “Because you hurt me and I’ve asked you to leave me alone. You’re choosing not to respect that and I’m tired of it.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("His eyes hold me. “When did you start to hate me so much? God, we went through so much together with your nan and you just leave me without an explanation?”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“Without an explanation?” I cry, my emotions taking over. “You were kissing another woman!”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“It wasn’t what you think, you should have known me better. I’d never do anything to hurt you. If you had let me explain, you’d know that. Stop using your insecurities as a barrier, Lara. You know me.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("I flinch.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("My insecurities. Another consequence of losing Nan. When I first met Noah, I never thought twice about being good enough. The day I lost Nan was the day the confidence floated away, as if she took it with her when she died. I became a shell of a person. I stopped loving who I was, yet Noah stood beside me. He held my hand through it all, through the ups and downs, through the pain and heartache. Through the change in who I was. Yet it only confirmed my feelings that I wasn’t good enough for him. He loved me, I knew that, but I knew it was a matter of time before he’d go looking for more.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“Get off me Noah,” I say, my voice weak, tired.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“Come on, Lara,” he rasps. “It’s me. Stop the act, you know I’d never hurt you.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“I don’t know a damned thing,” I snap. “All I know is what I saw. I saw you with a woman on your lap, and she was kissing you. And the sad part is, I know what I became—why you would have wanted her—so you don’t need to explain anything.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“My God,” he growls, seeming to finally crack and let a little of his anger show. “You have no fucking idea, do you?”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“Just leave me alone, "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("please")]), _vm._v(".”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“Lara, fuck…”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“I don’t want to talk to you, Noah, now leave me alone.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“No,” he growls. “For once in your life you’re going to stop with the fucking games.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("Games?")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("Is he serious?")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("That both stings and makes me angry.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“Get off me, now!” I yell, which is pathetic even to my ears.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“Ma’am, is everything okay here?”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("I look past Noah to see a police officer standing, glaring at Noah. I shouldn’t do it, I shouldn’t, but I just want to be left the hell alone. I’m trying to move on and he’s making it impossible for me. Memories of that woman in his arms flitter through my mind and push me to open my mouth and say, “No, it’s not okay. He won’t get off me.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("The pain and anger in Noah’s eyes as he looks at me with utter horror and shock break my heart.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("I turn my head to the side and look away.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“You know what,” he says, pushing off me. “You’re not worth it.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("Those words wound me more than I could have ever imagined.")]), _vm._v(" "), _c('p', {
    staticClass: "page-break"
  }), _vm._v(" "), _c('p', {
    staticClass: "sp"
  }), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("The tension is there, ready and waiting.")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("The more she rejects him, the angrier he gets. That’s exactly how I want him: irritated and exasperated.")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("He needs to have resentment. It’s vital to my plan.")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("I’m going to encourage that along, and I know just how to do it.")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("My game won’t be nearly as satisfying if they work together. He needs to be livid.")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("She needs to be weak and broken, fragile even.")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Then my game will be ready to be played.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ba559e10","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/chapter3.vue
// module id = 75
// module chunks = 0